
<div>
    <b-modal id="resolve" @show="getConflicts">
        <h3>Bekräfta importering av lista</h3>
        {{ this.conflicts.length }}
        <b-table small :fields="fields" :items="conflicts" />
    </b-modal>
</div>
